// extracted by mini-css-extract-plugin
module.exports = {"ProfileTitle__main":"ProfileTitle_ProfileTitle__main__NbLLd","ProfileTitle__sub":"ProfileTitle_ProfileTitle__sub__Zhvl9"};